export function mapApiToRowData(apiData) {
  if (!apiData) {
    console.warn("⚠️ [mapApiToRowData] No API data received");
    return [];
  }

  const getName = (obj) => {
    if (!obj) {
      return null;
    }

    if (typeof obj === "object") {
      const id = obj.id ?? obj.value ?? "";
      const name = obj.name ?? obj.label ?? "";
      return { id, name };
    }

    // String value fallback (like "BAG")
    return { id: obj, name: obj };
  };

  const makeRow = (
    id,
    type,
    perc,
    rate,
    rateQuantityObj,
    qty,
    desc,
    tVal = null,
    tValQuantityObj = null
  ) => {
    console.groupCollapsed(`🧩 [makeRow] Building row → ${id}`);

    const row = {
      id,
      cesstype: [type || ""],
      cessrate: [
        perc ?? 0,
        "% Or Rs",
        rate ?? 0,
        "/",
        getName(rateQuantityObj) || null, // { id, name }
      ],
      tariffValue:
        id === "row-2"
          ? [
              tVal ?? 0,
              "/",
              getName(tValQuantityObj) || null, // { id, name }
            ]
          : [],
      quantity: [qty?.toString() || "0"],
      description: [desc || ""],
    };

    console.groupEnd();
    return row;
  };


  const rows = [
    makeRow(
      "row-1",
      apiData.exportProductExportDutyCessDuty,
      apiData.exportProductExportDutyCessDutyPercentage,
      apiData.exportProductExportDutyCessDutyRates,
      apiData.exportProductExportDutyCessDutyRatesQuantity,
      apiData.exportProductExportDutyQtyForCessDuty
    ),
    makeRow(
      "row-2",
      apiData.exportProductCessCessDuty,
      apiData.exportProductCessCessDutyPercentage,
      apiData.exportProductCessCessDutyRates,
      apiData.exportProductCessCessDutyRatesQuantity,
      apiData.exportProductCessQtyForCessDuty,
      apiData.exportProductCessCessDesc,
      apiData.exportProductCessTarriffValue,
      apiData.exportProductCessTarriffValueQuantity
    ),
    makeRow(
      "row-3",
      apiData.exportProductOtherDutyCessDuty,
      apiData.exportProductOtherDutyCessDutyPercentage,
      apiData.exportProductOtherDutyCessDutyRates,
      apiData.exportProductOtherDutyCessDutyRatesQuantity,
      apiData.exportProductOtherDutyQtyForCessDuty,
      apiData.exportProductOtherDutyCessDesc
    ),
    makeRow(
      "row-4",
      apiData.exportProductThirdCessCessDuty,
      apiData.exportProductThirdCessCessDutyPercentage,
      apiData.exportProductThirdCessDutyRates,
      apiData.exportProductThirdCessDutyRatesQuantty,
      apiData.exportProductThirdCessQtyForCessDuty,
      apiData.exportProductThirdCessCessDesc
    ),
  ];

  console.groupEnd();
  console.groupEnd();

  return rows;
}




// ✅ Row → Payload Mapper
export function mapRowDataToPayload(rowsObj = {}) {
  const parseNum = (val) => {
    if (val === null || val === undefined || val === "" || val === "-")
      return null;
    const num = parseFloat(val);
    return isNaN(num) ? null : num;
  };
  

  const payload = {
    exportProductIsCessExpDutyIsLeviable: true,
  };

  Object.entries(rowsObj).forEach(([rowKey, row]) => {
    if (!row) return;
    const cesstype = row.cesstype?.[0] || "";
    const cessRateArr = row.cessrate || [];
    const cessPerc = parseNum(cessRateArr[0]);
    const cessrate = parseNum(cessRateArr[2]);
    const cessRateQuantityId =
    typeof cessRateArr[4] === "object"
      ? cessRateArr[4]?.id
      : cessRateArr[4] || null;
  
  

      const quantityArr = row.quantity || [];
    const quantityValue = parseNum(quantityArr[0]);

    const cessDesc = row.description?.[0] || "";

    const tariffArr = row.tariffvalue || [];
    const tariffValue = parseNum(tariffArr[0]);
    const tariffValueQuantityId =
    typeof tariffArr[2] === "object"
      ? tariffArr[2]?.id
      : tariffArr[2] || null;
  

    switch (rowKey) {
      case "row-1":
        if (cesstype) payload.exportProductExportDutyCessDuty = cesstype;
        if (cessPerc !== null)
          payload.exportProductExportDutyCessDutyPercentage = cessPerc;
        if (cessrate !== null)
          payload.exportProductExportDutyCessDutyRates = cessrate;
        if (cessRateQuantityId)
          payload.exportProductExportDutyCessDutyRatesQuantity = cessRateQuantityId;
        if (quantityValue !== null)
          payload.exportProductExportDutyQtyForCessDuty = quantityValue;
        break;

      case "row-2":
        if (cesstype) payload.exportProductCessCessDuty = cesstype;
        if (cessPerc !== null)
          payload.exportProductCessCessDutyPercentage = cessPerc;
        if (cessrate !== null)
          payload.exportProductCessCessDutyRates = cessrate;
        if (cessRateQuantityId)
          payload.exportProductCessCessDutyRatesQuantity = cessRateQuantityId;

        if (tariffValue !== null)
          payload.exportProductCessTarriffValue = tariffValue;
        if (tariffValueQuantityId)
          payload.exportProductCessTarriffValueQuantity = tariffValueQuantityId;

        if (quantityValue !== null)
          payload.exportProductCessQtyForCessDuty = quantityValue;
        if (cessDesc) payload.exportProductCessCessDesc = cessDesc;
        break;

      case "row-3":
        if (cesstype) payload.exportProductOtherDutyCessDuty = cesstype;
        if (cessPerc !== null)
          payload.exportProductOtherDutyCessDutyPercentage = cessPerc;
        if (cessrate !== null)
          payload.exportProductOtherDutyCessDutyRates = cessrate;
        if (cessRateQuantityId)
          payload.exportProductOtherDutyCessDutyRatesQuantity = cessRateQuantityId;
        if (quantityValue !== null)
          payload.exportProductOtherDutyQtyForCessDuty = quantityValue;
        if (cessDesc) payload.exportProductOtherDutyCessDesc = cessDesc;
        break;

      case "row-4":
        if (cesstype) payload.exportProductThirdCessCessDuty = cesstype;
        if (cessPerc !== null)
          payload.exportProductThirdCessCessDutyPercentage = cessPerc;
        if (cessrate !== null)
          payload.exportProductThirdCessDutyRates = cessrate;
        if (cessRateQuantityId)
          payload.exportProductThirdCessDutyRatesQuantty = cessRateQuantityId;
        if (quantityValue !== null)
          payload.exportProductThirdCessQtyForCessDuty = quantityValue;
        if (cessDesc) payload.exportProductThirdCessCessDesc = cessDesc;
        break;
    }
  });

  return { cessExpDuty: payload };
}
